import React from 'react';
import { FaCalendarAlt, FaComments, FaFileAlt, FaCog } from 'react-icons/fa';

const Card = ({ title, subtitle, Icon, iconColor, onClick, cardClass }) => (
  <button className={`menu-card ${cardClass || ''}`} onClick={onClick}>
    <div className="menu-icon" aria-hidden>
      <Icon className={`size-8 ${iconColor}`} />
    </div>
    <div className="menu-title">{title}</div>
    {subtitle && <div className="menu-subtitle">{subtitle}</div>}
  </button>
);

const SchedulingMenu = ({ goBack, toOutcomes, toSettings, logout, onSelect }) => {
  return (
    <div className="menu-screen">
      <h1 className="menu-heading">Scheduling/Communication Error</h1>
      <p className="menu-sub">Select the type of scheduling or communication error</p>
      <div className="menu-grid three-cols">
        <Card 
          title="Appointment Scheduling" 
          subtitle="Double bookings, incorrect times, and scheduling conflicts" 
          Icon={FaCalendarAlt} 
          iconColor="text-indigo-600"
          onClick={() => onSelect('Scheduling - Appointment')} 
          cardClass="scheduling" 
        />
        <Card 
          title="Patient Communication" 
          subtitle="Missed calls, incorrect information, and communication breakdowns" 
          Icon={FaComments} 
          iconColor="text-indigo-600"
          onClick={() => onSelect('Scheduling - Communication')} 
          cardClass="scheduling" 
        />
        <Card 
          title="Documentation Error" 
          subtitle="Chart errors, missing information, and record-keeping issues" 
          Icon={FaFileAlt} 
          iconColor="text-indigo-600"
          onClick={() => onSelect('Scheduling - Documentation')} 
          cardClass="scheduling" 
        />
        <Card 
          title="System/Process Error" 
          subtitle="Workflow problems, system failures, and process breakdowns" 
          Icon={FaCog} 
          iconColor="text-indigo-600"
          onClick={() => onSelect('Scheduling - System/Process')} 
          cardClass="scheduling" 
        />
      </div>
    </div>
  );
};

export default SchedulingMenu;
